// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"EditUser_loadingContainer__2g6ic","loadingAnimation":"EditUser_loadingAnimation__3Qh7U","loadingText":"EditUser_loadingText__2LKGF"};